<template>
    <v-table
      class="table-data"
      fixed-header>
      <thead>
        <tr>
          <th v-for="item in headers"
            :key="item" class="text-left">
            {{item}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in Products"
          :key="item._id">
          <td> <img class="img-item-table"
            :src="item.img ? item.img : require('@/assets/imgs/png/product_default.png')"/></td>
          <td>
            {{ item.name }}
            <v-icon v-if="item.favorites" color="orange">mdi-star</v-icon>
          </td>
          <td>{{ formatTimestamp(item.updated_at) }}</td>
          <td>{{item.sku }}</td>
          <td>{{item.prep_time }}</td>
          <!--
          <td>
             <img
              :src="item.available_pos
              ? require('@/assets/imgs/svgs/check-circle.svg')
              : require('@/assets/imgs/svgs/uncheck-circle.svg')"/>
          </td>
          <td>
            <img
              :src="item.available_so
              ? require('@/assets/imgs/svgs/check-circle.svg')
              : require('@/assets/imgs/svgs/uncheck-circle.svg')"/>
          </td>
          -->
          <td>{{item.stock }}</td>
          <td>{{formatMoney(item.price )}}</td>
          <td>{{formatMoney(item.promo_price || 0) }}</td>
          <td>
            <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"/>
            </template>
            <v-list>
              <v-list-item  title="Editar" link
              @click="editModal(item)"/>
              <v-list-item  title="Eliminar" link
              @click="openDialogDelete(item)"/>
            </v-list>
          </v-menu>
          </td>
        </tr>
      </tbody>
    </v-table>

    <add-edit-products ref="addEditModal" @refreshList="refresh"/>

    <diaog-two-options
    ref="deleteDialog"
    @okBtn="deleteObj"
    title="Eliminar producto"
    txtBtn="Sí, Eliminar"
    :txtBold="objSelected?.name || ''"
    txtOne="¿Deseas eliminar "
    txtTwo="? No podrás deshacer la acción."/>
</template>
<script>
import AddEditProducts from '../forms/AddEditProducts.vue'
import DiaogTwoOptions from '../dialogs/DiaogTwoOptions.vue'
import catalogApi from '@/api/catalogApi'
import dateTransform from '@/utils/dateTransform'
import moneyTransform from '@/utils/moneyTransform'
export default {
  name: 'CommerciaVueCatalogTable',
  components: {
    AddEditProducts,
    DiaogTwoOptions
  },
  props: {
    Products: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      objSelected: null,
      headers: ['', 'Producto', 'Editado', 'Código', 'Preparación', 'Existencias', 'Precio Reg', 'Precio Esp.', 'Acciones']
    }
  },
  methods: {
    editModal (obj) {
      this.$refs.addEditModal.edit(obj)
    },
    openDialogDelete (obj) {
      this.objSelected = obj
      this.$refs.deleteDialog.open()
    },
    async deleteObj () {
      console.log(this.objSelected)
      if (await catalogApi.delete(this.objSelected)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    refresh () { this.$emit('refreshList') },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    },
    formatMoney (intValue) {
      return moneyTransform.intToMoney(intValue)
    }
  }
}
</script>
<style scoped>
  @import '@/assets/styles/tables.css';
</style>
